import { useRef, useEffect, useState } from 'react';

/**
 * Observes content height and calculates height based on ratio.
 * Returns the calculated height and a ref that should be attached to the content container element.
 */
export const useGetHeightFromContentObserver = (ratio: number) => {
  const boxRef = useRef<HTMLDivElement>(null);
  const [observedHeight, setObservedHeight] = useState<number>(0);

  useEffect(() => {
    const boxElement = boxRef.current;
    if (!boxElement) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        let observedHeight: number;

        // Use borderBoxSize to include padding and border
        if (entry.borderBoxSize && entry.borderBoxSize.length > 0) {
          const { blockSize } = entry.borderBoxSize[0];
          observedHeight = blockSize * ratio;
        } else {
          // Fallback to getBoundingClientRect if borderBoxSize is not available
          const rect = entry.target.getBoundingClientRect();
          observedHeight = rect.height * ratio;
        }

        setObservedHeight(observedHeight);
      }
    });

    resizeObserver.observe(boxElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ratio]);

  return { observedHeight, boxRef };
};
